<template>
  <Modal title="发送邮件" v-model="visibleThis" width="800" :mask-closable="false">
    <Form
      ref="emailForm"
      class="form"
      :label-width="80"
      :model="emailParam"
      :rules="emailRule"
    >
      <Row>
        <Col :span="22">
          <Form-item label="老师ID">
            <Input v-model="emailParam.tchId" disabled></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="老师昵称">
            <Input v-model="tchName" disabled></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="邮件标题" prop="title">
            <Input v-model="emailParam.title" placeholder="请输入邮件标题"></Input>
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="邮件内容" prop="content">
            <quillEditor 
              v-model="emailParam.content" 
              ref="myQuillEditor" 
              :options="editorOption"
            ></quillEditor>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="default" size="large" class="cancel" @click="visibleThis = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingSend"
        @click="sendEmail"
      >
        确定
      </Button>
    </div>
  </Modal>
</template>

<script>
import * as Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'

var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  name: 'SendEmailModal',
  components: {
    quillEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: [Number, String],
      default: null
    },
    tchName: {
      type: String,
      default: ''
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      visibleThis: this.visible,
      loadingSend: false,
      emailParam: {
        tchId: '',
        title: '',
        content: ''
      },
      emailRule: {
        title: [
          { type: 'string', required: true, message: '邮件标题不能为空', trigger: 'blur' },
          { type: 'string', max: 100, message: '邮件标题不能超过100个字', trigger: 'blur' }
        ],
        content: [
          { type: 'string', required: true, message: '邮件内容不能为空', trigger: 'change' }
        ]
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'color': []}, {'background': []}],
            [{'align': []}],
            [{ 'font': fonts }],
            ['clean'],
            ['link']
          ]
        }
      }
    }
  },
  methods: {
    cancel () {
      this.resetForm()
      this.visibleThis = false
    },
    sendEmail () {
      let self = this
      self.loadingSend = true
      self.$refs.emailForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingSend = false
          return
        }
        // 调用发送邮件API
        self.$http.post('/tch/send-email', self.emailParam).then(function (res) {
          self.$Message.success('邮件发送成功!')
          self.visibleThis = false
          self.loadingSend = false
          if (self.successCallback) {
            self.successCallback()
          }
        }).catch(function (e) {
          self.$Message.error('邮件发送失败!')
          self.loadingSend = false
        })
      })
    },
    resetForm () {
      this.emailParam = {
        tchId: this.tchId,
        title: '',
        content: ''
      }
      if (this.$refs.emailForm) {
        this.$refs.emailForm.resetFields()
      }
      // 清空富文本编辑器内容
      if (this.$refs.myQuillEditor) {
        this.$refs.myQuillEditor.quill.setText('')
      }
    }
  },
  watch: {
    visible (val) {
      this.visibleThis = val
    },
    visibleThis (val) {
      if (!val) {
        this.resetForm()
        this.$emit('on-close')
        // this.$emit('on-close', val)
      }
    },
    tchId (val) {
      this.emailParam.tchId = val
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .quill-editor {
  .ql-container {
    height: 300px;
    overflow-y: auto;
  }
  .ql-editor {
    min-height: 300px;
  }
}

/deep/ .ivu-modal-footer {
  position: relative;
  z-index: 10;
}

.cancel {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// SendEmailModal.vue?596cc920